import { BrowserRouter as Router, Routes, Route, BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import Inicio from "./components/Inicio";
import Navbar from "./components/Navbar";
import Premios from "./components/Premios";
import Miniprint from "./components/Miniprint";

import AcercaDeMi from "./components/AcercaDeMi";
import Footer from "./components/Footer";
import Form from "./components/Form"
import Dialogos from "./components/Dialogos";
import Peces from "./components/Peces"
import PequeñosMundos from "./components/PequeñosMundos"
import './css/app.css'
import Exposiciones from "./components/Exposiciones";
import Intervenidos from "./components/Intervenidos";
import Monocopias from "./components/Monocopias";
import Profundidades from "./components/Profundidades";



function App() {
  useEffect(() => {
    fetch("https://elsaback.onrender.com/ping")
      .catch((err) => console.error("Backend aún no responde", err));
  }, []);
  return (
   <>
   <div style={{zIndex: '10', backgroundColor:'#eee', display:'flex', alignItems:'center', flexDirection:'column'}}>
    <BrowserRouter>
      <header id="top" style={{zIndex:'200', width:'100%'}}>
        <Navbar/>
      </header>
      <main className="main" style={{width:'100%', display:'flex', justifyContent:'center', position:'relative', minHeight:'80vh'}}>
        
        <Routes>
          <Route path="/*" element={<Inicio/>}></Route>
          <Route path="/acercaDeMi" element={<AcercaDeMi/>}></Route>
          <Route path='/contacto' element={<Form/>}></Route>
          <Route path='/miniprint' element={<Miniprint/>}></Route>
          <Route path="/dialogos" element={<Dialogos/>}></Route>
          <Route path="/peces" element={<Peces/>}></Route>
          <Route path="/pequeñosMundos" element={<PequeñosMundos/>}></Route>
          <Route path="/premios" element={<Premios/>}></Route>
          <Route path="/exposiciones" element={<Exposiciones/>}></Route>
          <Route path="/intervenidos" element={<Intervenidos/>}></Route>
          <Route path="/monocopias" element={<Monocopias/>}></Route>
          <Route path="/profundidades" element={<Profundidades/>}></Route>
        </Routes>
      
      </main>
    </BrowserRouter>
    <footer style={{display:"flex", width:'100%'}}>
      <Footer/>
    </footer>
   </div>
   
   </>
  );
}

export default App;
